module.exports = __webpack_public_path__ + "img/inspirer-of-ideas-4.e2695a23.svg";